module.exports = __webpack_public_path__ + "media/images/emblems/Bussy-sur-Moudon-coat_of_arms-cce7020c9a0ce74b2c7c8cc966f7d85a.svg";